"use client";

import { useMemo } from "react";
import { useAprs } from "@/hooks/use-aprs";

interface HighestAprResult {
  highestApr: number;
  highestStrike: string | null;
  isLoading: boolean;
  error: string | null;
}

export function useHighestApr(): HighestAprResult {
  const { data, isLoading, error } = useAprs();

  const { highestApr, highestStrike } = useMemo(() => {
    if (!data) return { highestApr: 0, highestStrike: null as string | null };
    const strikes = new Set<string>([
      ...Object.keys(data.bgt || {}),
      ...Object.keys(data.beradrome || {}),
    ]);
    let maxApr = 0;
    let best: string | null = null;
    for (const s of strikes) {
      const bgt = data.bgt[s]?.apr ?? 0;
      const ob = data.beradrome[s]?.apr ?? 0;
      const total = bgt + ob;
      if (total > maxApr) {
        maxApr = total;
        best = s;
      }
    }
    return { highestApr: maxApr, highestStrike: best };
  }, [data]);

  return {
    highestApr,
    highestStrike,
    isLoading,
    error: error ? "Failed to fetch APRs" : null,
  };
}
